









import { Component, Mixins, Prop } from "vue-property-decorator";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../..";
import {
  CommonComponentsAccessibleMixin,
} from "../../mixins";

@Component({
  components: {
    MenuPane,
  }
})
export default class PreviewMenu extends Mixins(
  ModelEditableMixin,
  CommonComponentsAccessibleMixin,
) {
  @Prop({ default: false })
  isHorizontal: boolean;

  editingSource: EditingDocument;

  printPdfPreview(): void {
    this.commonComponents.dialogs.printer.preview
    .show(this.editingSource.source, this.editingSource.currentSectionIndex + 1, !this.editingSource.isPrintingDisabled && this.isPrintable, this.shouldShowPrintPreview)
    .catch(e => {
      this.$error(
        "印刷プレビュー表示エラー",
        "印刷プレビューを表示できませんでした。",
        e
      );
    });
  }

  get classNameTooltip(): string {
    return this.isHorizontal ? "" : "vertical-preview-menu-tooltip-content";
  }

  get isPreviewEnable(): boolean {
    return this.readPropertyOrDefault(s => !s.isPreviewDisabled, true);
  }

  get isPrintable(): boolean {
    return this.$configuration.behavior.document.editor.previewMenu.printing.isEnable;
  }

  get shouldShowPrintPreview(): boolean {
    return this.$configuration.behavior.document.editor.previewMenu.shouldShowPrintPreview;
  }
}
